import React from 'react';
import styled from 'styled-components';

const SkillBadgeStyle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 2rem;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--text-primary);
  transition: var(--transition-normal);
  cursor: default;
  
  .skill-icon {
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  &:hover {
    background: var(--gradient-primary);
    border-color: transparent;
    transform: translateY(-3px);
    box-shadow: var(--shadow-glow);
  }
  
  @media only screen and (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 1.3rem;
    
    .skill-icon {
      font-size: 1.8rem;
    }
  }
`;

export default function SkillBadge({ icon, name }) {
  return (
    <SkillBadgeStyle>
      {icon && <span className="skill-icon">{icon}</span>}
      <span>{name}</span>
    </SkillBadgeStyle>
  );
}
